<div class="w-full h-full p-1">
  <app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
    <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
      <p-dialog [draggable]="false" [(visible)]="configMissing" [closable]="false" appendTo="self">
        <i style="font-size: 10px" class="pi pi-exclamation-circle pr-1"></i> <label>Well Configuration Missing: Please specify at least one string</label> <br />
        <br />
      </p-dialog>

      @if (cementingLandingForm) {
        <form [formGroup]="cementingLandingForm" [hidden]="isLoading()">
          <div class="flex flex-wrap gap-2 m-2">

            <div class="flex-1">
              <p-fieldset legend="Cementing Inputs">
                <div class="mb-2">
                  <p-fieldset [class.opacity-50]="!stringCemented" legend="Lead Slurry">
                    <label [class.opacity-50]="!stringCemented" for="leadSlurryDensity">Slurry Density</label>
                    <app-validated-number-input
                      [id]="'leadSlurryDensity'"
                      [control]="control('leadSlurryDensity')"
                      [value]="control('leadSlurryDensity').value"
                      [validation]="slurryDensityValidation"
                      [unit]="densityUnits">
                    </app-validated-number-input>
                  </p-fieldset>
                </div>

                <p-fieldset>
                  <ng-template pTemplate="header">
                    <div class="flex h-5">
                      <p-toggleswitch [class.pointer-events-none]="!stringCemented" (onChange)="onTailChange($event)" formControlName="hasTailCement" inputId="hasTailCement"
                        binary="true">
                      </p-toggleswitch>
                      <label [class.opacity-50]="!stringCemented" for="hasTailCement" class="ml-2"> Tail Slurry</label>
                    </div>
                  </ng-template>

                  <div class="space-y-2">
                    <div class="flex flex-col">
                      <label [class.opacity-50]="!stringCemented" for="tailSlurryDensity">Slurry Density</label>
                      <app-validated-number-input
                        [id]="'tailSlurryDensity'"
                        [control]="control('tailSlurryDensity')"
                        [value]="control('tailSlurryDensity').value"
                        [validation]="slurryDensityValidation"
                        [unit]="densityUnits"
                      ></app-validated-number-input>
                    </div>

                    <div class="flex flex-col">
                      <label [class.opacity-50]="!stringCemented" for="tailSlurryLength">Slurry Length</label>
                      <app-validated-number-input
                        [id]="'tailSlurryLength'"
                        [control]="control('tailSlurryLength')"
                        [value]="control('tailSlurryLength').value"
                        [validation]="{ min: 0, max: maxTailSlurryLength }"
                        [unit]="slurryLengthUnit"
                        (change)="changeHasTailSlurry($event)"
                      ></app-validated-number-input>
                    </div>
                  </div>
                </p-fieldset>

                <div class="pt-2 space-y-2">
                  <div class="flex flex-col">
                    <label for="displacementFluidDensity">Displacement Fluid</label>
                    <app-validated-number-input
                      [id]="'displacementFluidDensity'"
                      [control]="control('displacementFluidDensity')"
                      [value]="control('displacementFluidDensity').value"
                      [validation]="displacementDensityValidation"
                      [unit]="densityUnits"
                    ></app-validated-number-input>
                  </div>

                  <div class="flex flex-col">
                    <label [class.opacity-50]="!stringCemented" for="hardCement">Hard Cement</label>
                    <p-select class="w-full" dataKey="id" [title]="hardCementJson" [options]="_hardCement" formControlName="cement"
                      [placeholder]="getPlaceholderText(cementingLandingForm.controls.cement.value)" appendTo="body">
                      <ng-template pTemplate="selectedItem">
                        {{ getPlaceholderText(cementingLandingForm.controls.cement) }}
                      </ng-template>
                      <ng-template let-cement pTemplate="item">
                        {{ cement.name }}
                      </ng-template>
                    </p-select>
                  </div>
                </div>
              </p-fieldset>
            </div>

            <div class="flex-1">
              <p-fieldset legend="Landing Details">

                <div class="space-y-2">
                  <div class="flex flex-col">
                    <label [class.opacity-50]="!stringCemented" for="pickupAfterCementSet">Pickup/Slackoff On TOC
                      <i pTooltip="Pickup (+)/Slackoff (-)" class="pi pi-info-circle cursor-help"></i>
                    </label>
                    <app-validated-number-input
                      [id]="'pickupAfterCementSet'"
                      [control]="control('pickupAfterCementSet')"
                      [value]="control('pickupAfterCementSet').value"
                      [validation]="{ min: -100000000, max: 100000000 }"
                      [unit]="forceUnits"
                    ></app-validated-number-input>
                  </div>

                  <div class="flex flex-col">
                    <label for="slackoffForceOnBottom">Slackoff Force On Bottom
                      <i pTooltip="Pickup (-)/Slackoff (+) &#13;This option can be used to approximate known friction loads encountered during tripping the pipe into the hole, &#13;or slackoff prior to cementing with the pipe fully landed out in the bottom of the as-drilled borehole."
                        class="pi pi-info-circle cursor-help">
                      </i>
                    </label>
                    <app-validated-number-input
                      [id]="'slackoffForceOnBottom'"
                      [control]="control('slackoffForceOnBottom')"
                      [value]="control('slackoffForceOnBottom').value"
                      [validation]="{ min: -100000000, max: 100000000 }"
                      [unit]="forceUnits"
                    ></app-validated-number-input>
                  </div>
                </div>

              </p-fieldset>
            </div>

          </div>

        </form>
      }
    </p-scrollPanel>
  </app-tool-loader>
</div>